import React from "react";
import { createRoot } from "react-dom/client";
import VideoHero from "../components/VideoHero.js";

const videoRoots = new WeakMap();

const renderHeroVideo = ($, $context = $(document)) => {
	const videoContainers = $context.find(".js-video-hero-block").toArray();
	if (!videoContainers.length) return;

	videoContainers.forEach((videoContainer) => {
		const props = {
			...videoContainer.dataset,
		};
		let root = videoRoots.get(videoContainer);

		if (!root) {
			root = createRoot(videoContainer);
			videoRoots.set(videoContainer, root);
		}

		root.render(<VideoHero {...props} />);
	});
};

export default renderHeroVideo;
